import { defineComponent as i, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as A } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, f = { key: 1 }, h = { key: 2 }, k = { key: 3 }, w = { key: 4 }, L = { key: 5 }, M = {
  name: "ScalarIconArrowBendRightUp"
}, _ = /* @__PURE__ */ i({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = m(s);
    return (p, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(p.$slots, "default"),
      e(a) === "bold" ? (l(), o("g", V, t[0] || (t[0] = [
        n("path", { d: "M208.49,88.49a12,12,0,0,1-17,0L164,61v67A108.12,108.12,0,0,1,56,236a12,12,0,0,1,0-24,84.09,84.09,0,0,0,84-84V61L112.49,88.49a12,12,0,0,1-17-17l48-48a12,12,0,0,1,17,0l48,48A12,12,0,0,1,208.49,88.49Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (l(), o("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M200,80H104l48-48Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M205.66,74.34l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,104,88h40v40a88.1,88.1,0,0,1-88,88,8,8,0,0,0,0,16A104.11,104.11,0,0,0,160,128V88h40a8,8,0,0,0,5.66-13.66ZM123.31,72,152,43.31,180.69,72Z" }, null, -1)
      ]))) : e(a) === "fill" ? (l(), o("g", h, t[2] || (t[2] = [
        n("path", { d: "M207.39,83.06A8,8,0,0,1,200,88H160v40A104.11,104.11,0,0,1,56,232a8,8,0,0,1,0-16,88.1,88.1,0,0,0,88-88V88H104a8,8,0,0,1-5.66-13.66l48-48a8,8,0,0,1,11.32,0l48,48A8,8,0,0,1,207.39,83.06Z" }, null, -1)
      ]))) : e(a) === "light" ? (l(), o("g", k, t[3] || (t[3] = [
        n("path", { d: "M204.24,84.24a6,6,0,0,1-8.48,0L158,46.49V128A102.12,102.12,0,0,1,56,230a6,6,0,0,1,0-12,90.1,90.1,0,0,0,90-90V46.49L108.24,84.24a6,6,0,0,1-8.48-8.48l48-48a6,6,0,0,1,8.48,0l48,48A6,6,0,0,1,204.24,84.24Z" }, null, -1)
      ]))) : e(a) === "regular" ? (l(), o("g", w, t[4] || (t[4] = [
        n("path", { d: "M205.66,85.66a8,8,0,0,1-11.32,0L160,51.31V128A104.11,104.11,0,0,1,56,232a8,8,0,0,1,0-16,88.1,88.1,0,0,0,88-88V51.31L109.66,85.66A8,8,0,0,1,98.34,74.34l48-48a8,8,0,0,1,11.32,0l48,48A8,8,0,0,1,205.66,85.66Z" }, null, -1)
      ]))) : e(a) === "thin" ? (l(), o("g", L, t[5] || (t[5] = [
        n("path", { d: "M202.83,82.83a4,4,0,0,1-5.66,0L156,41.66V128A100.11,100.11,0,0,1,56,228a4,4,0,0,1,0-8,92.1,92.1,0,0,0,92-92V41.66L106.83,82.83a4,4,0,0,1-5.66-5.66l48-48a4,4,0,0,1,5.66,0l48,48A4,4,0,0,1,202.83,82.83Z" }, null, -1)
      ]))) : A("", !0)
    ], 16));
  }
});
export {
  _ as default
};
